'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.controller_device_edit', {
    url: '/company/:company_id/controller_edit/:id',
    template: '<oem-controller-device-edit></oem-controller-device-edit>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/controller_edit/controller_edit.routes.js